/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.TRIGGER_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, TriggerRowInput, TriggerRow, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * trigger_row on the server. Only name, description and trigger_row type need to be specified for this purpose.
 * @param trigger_rowInput An object of type TriggerRowInput containing the input data for creating the trigger_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_trigger_row(trigger_rowInput: TriggerRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: trigger_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * trigger_row on the server.
 * @param trigger_row An object of type TriggerRow containing the updated trigger_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_trigger_row(trigger_row: TriggerRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: trigger_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of trigger_rows
 * on the server.
 * @param trigger_id Optional. The UUID of the trigger to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_trigger_rows(trigger_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER_ROW,
        method: HttpMethods.GET,
        query_parameters: { trigger_id: trigger_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * trigger_row on the server.
 * @param trigger_row_id The UUID of the trigger_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_trigger_row(trigger_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { trigger_row_id: trigger_row_id },
    };
}
